export default __webpack_public_path__ + "static/media/xpollinate.60d5613f.svg";